import { ArrowClockwise } from "@styled-icons/bootstrap";
import { AllWidgetTypes } from "components/widgets";
import { useEffect, useState } from "react";
import { QuickAction } from "types/Widget";

import { WidgetAction } from "./BlankAction";
// import deepEqual from "deep-equal";

export const ResetAction: QuickAction = ({ widgetTypeId, widgetState, setWidgetState }) => {
  // const [isVisible, setIsVisible] = useState<boolean>(false);
  const [timer, setTimer] = useState<NodeJS.Timeout>();

  useEffect(() => {
    if (!timer) {
      //Doing an almost-debouncey thing here. Basically we check
      // immediately so that any change gets automatically processed, and then we
      // debounce later calls
      // setIsVisible(!deepEqual(AllWidgetTypes[widgetTypeId].defaultState, widgetState));
    } else {
      clearTimeout(timer);
    }

    setTimer(
      setTimeout(() => {
        // setIsVisible(!deepEqual(AllWidgetTypes[widgetTypeId].defaultState, widgetState));
        setTimer(undefined);
      }, 300),
    );

    return () => {
      if (timer) {
        clearTimeout(timer);
        setTimer(undefined);
      }
    };
  }, [widgetTypeId, widgetState]);

  const resetData = () => {
    setWidgetState(AllWidgetTypes[widgetTypeId].defaultState, true);
  };

  // if (!isVisible) return <></>;

  return (
    <WidgetAction onClick={resetData}>
      <ArrowClockwise height={"100%"} color="var(--primary)" />
      <p>Reset</p>
    </WidgetAction>
  );
};
